module.exports = __webpack_public_path__ + "resources/shop_bg.39d1f27edcdf876a.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-welfare-v2/img/shop_bg.png
// module id = 759
// module chunks = 0 2